import { render, staticRenderFns } from "./HeaderSelector.vue?vue&type=template&id=1a9ae5bd&scoped=true"
import script from "./HeaderSelector.vue?vue&type=script&lang=js"
export * from "./HeaderSelector.vue?vue&type=script&lang=js"
import style0 from "./HeaderSelector.vue?vue&type=style&index=0&id=1a9ae5bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9ae5bd",
  null
  
)

export default component.exports